import React from 'react';
import { Modal, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useMySubscriptionId } from '../../../hooks/subscription/useMySubscriptionId';
import { RECEPTIONIST_AI_PAGE_PATH } from '../../../pages/receptionist_ai/ReceptionistAiListPage';
import './AdminOnlyModal.css';

interface AdminOnlyModalProps {
  isOpen: boolean;
  onDismiss: () => void;
}

const AdminOnlyModal: React.FC<AdminOnlyModalProps> = ({ isOpen, onDismiss }) => {
  const navigate = useNavigate();
  const mySubscriptionId = useMySubscriptionId();

  return (
    <Modal open={isOpen} onCancel={onDismiss} footer={null} centered width={480} className="admin-only-modal" closable={false}>
      <div className="admin-only-modal__content">
        <div className="admin-only-modal__icon-badge">
          <LockOutlined className="admin-only-modal__icon" />
        </div>
        <h3 className="admin-only-modal__title">Cette page est réservée aux administrateurs du compte</h3>
        <p className="admin-only-modal__description">
          Vous pouvez régler votre réceptionniste depuis l'onglet « Réceptionniste IA ». Pour le reste,
          rapprochez-vous de l'administrateur de votre compte Leedflow.
        </p>
        <div className="admin-only-modal__actions">
          <Button className="admin-only-modal__dismiss-btn" onClick={onDismiss}>
            J'ai compris
          </Button>
          {mySubscriptionId && (
            <Button
              type="primary"
              className="admin-only-modal__confirm-btn"
              onClick={() => navigate(`${RECEPTIONIST_AI_PAGE_PATH}/${mySubscriptionId}`)}
            >
              Aller à mon réceptionniste
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AdminOnlyModal;
